import { render, staticRenderFns } from "./GradesMustGoUp.vue?vue&type=template&id=fb62b9fa&"
import script from "./GradesMustGoUp.vue?vue&type=script&lang=js&"
export * from "./GradesMustGoUp.vue?vue&type=script&lang=js&"
import style0 from "./GradesMustGoUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports